import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "dvAvailableFor",
  class: "position-relative"
}
const _hoisted_2 = { class: "font-size-16" }
const _hoisted_3 = {
  key: 0,
  class: "ajax-loader grid-listing"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  id: "dvSelectedOptionForParticipant",
  class: ""
}
const _hoisted_6 = {
  id: "dvAllParticipant",
  class: "display-flex"
}
const _hoisted_7 = { class: "margin-left-5 font-weight-bold" }
const _hoisted_8 = { id: "dvSelectedParticipant" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "display-flex" }
const _hoisted_11 = {
  key: 0,
  class: "position-relative no-participant-tooltip-div"
}
const _hoisted_12 = {
  key: 0,
  class: "filter-count-container"
}
const _hoisted_13 = { for: "Filter" }
const _hoisted_14 = { class: "showDvSelectedGroups" }
const _hoisted_15 = {
  key: 1,
  class: "position-relative margin-bottom-5"
}
const _hoisted_16 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputControlCheckBox = _resolveComponent("InputControlCheckBox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("Program.ListOfParticipantGroups.AvailableFor")), 1),
      _createElementVNode("i", {
        class: "margin-left-5 fa fa-info-circle information-icon",
        onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getInformationString(true, 'Available for'))),
        onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getInformationString(false,'Available for')))
      }, null, 32),
      _withDirectives(_createElementVNode("div", { class: "information-icon-divv" }, _toDisplayString(_ctx.$t("Program.ListOfParticipantGroups.ChooseYourAudienceAsRequied")), 513), [
        [_vShow, _ctx.showInformation]
      ])
    ]),
    (_ctx.localLinkedProgramLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("img", {
            class: "img-responsive ajax-loader-img",
            src: _ctx.loadingImage,
            alt: "Wait"
          }, null, 8, _hoisted_4)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", {
              class: "description",
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedOptionChange()))
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.hasSelectedGroups) = $event)),
                class: "radio-btn",
                type: "radio",
                name: "selectedOptionForParticipant",
                value: false
              }, null, 512), [
                [_vModelRadio, _ctx.hasSelectedGroups]
              ]),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("Program.ListOfParticipantGroups.ApplyToAllParticipant")), 1)
            ], 32)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", {
              class: "description",
              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedOptionChange()))
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.hasSelectedGroups) = $event)),
                class: "radio-btn",
                type: "radio",
                name: "selectedOptionForParticipant",
                value: true,
                disabled: !_ctx.isDisableCheckBox()
              }, null, 8, _hoisted_9), [
                [_vModelRadio, _ctx.hasSelectedGroups]
              ]),
              _createElementVNode("span", {
                class: _normalizeClass(["margin-left-5 font-weight-bold", {'color-darkgray': !_ctx.isDisableCheckBox()}])
              }, _toDisplayString(_ctx.$t("Program.ListOfParticipantGroups.ApplyToSelectedParticipantGroups")), 3)
            ], 32),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("p", {
                class: _normalizeClass(["subheadingitalic", [(!_ctx.isEnableParticipantList|| !_ctx.isGroupsAvailable && _ctx.participantGroups.length <= 0)? 'width70' : 'width100', {'color-darkgray': !_ctx.isDisableCheckBox()}]])
              }, _toDisplayString(_ctx.subHeading), 3),
              ( !_ctx.isEnableParticipantList|| !_ctx.isGroupsAvailable && _ctx.participantGroups.length <= 0 )
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("Program.ListOfParticipantGroups.NoPartcipantGroupExist")), 1),
                    _createElementVNode("i", {
                      class: "margin-left-5 fa fa-question-circle information-icon",
                      onMouseover: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getInformationString(true, 'Not Available'))),
                      onMouseleave: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getInformationString(false,'Not Available')))
                    }, null, 32),
                    _withDirectives(_createElementVNode("div", { class: "dvInfoForNotAvailableGroups" }, _toDisplayString(_ctx.$t("Program.ListOfParticipantGroups.NotAvailableInfoMsg")), 513), [
                      [_vShow, _ctx.showNotAvailableInformation]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.subModuleType == _ctx.selectedSubModuleType.Chat)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t("Dialogue.Filter.ChooseGroup")), 1),
                _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("EventSetting.Chat.GroupFilter", {participantCount : _ctx.selectedParticipantCount})), 1)
              ], 512)), [
                [_vShow, _ctx.isGroupsAvailable && _ctx.isEnableParticipantList]
              ])
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _withDirectives(_createElementVNode("div", null, [
              _createVNode(_component_InputControlCheckBox, {
                "input-data": _ctx.inputControlData,
                onCheckedItems: _ctx.SetSelectedParticipantGroupIds
              }, null, 8, ["input-data", "onCheckedItems"])
            ], 512), [
              [_vShow, _ctx.isGroupsAvailable && _ctx.isEnableParticipantList]
            ])
          ]),
          (_ctx.ShowGroupVisibilityCheckBox())
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("label", {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.SetGroupVisibilityCheckboxValue()))
                }, [
                  _withDirectives(_createElementVNode("input", {
                    ref: "chkGroupVisibility",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.localDisplayGroupInfoInApp) = $event)),
                    disabled: _ctx.selectedParticipantGroups.length === 0,
                    type: "checkbox",
                    class: "checkbox-alignment"
                  }, null, 8, _hoisted_16), [
                    [_vModelCheckbox, _ctx.localDisplayGroupInfoInApp]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("GroupVisibility.DisplayGroupInformationInApp")), 1)
                ]),
                _createElementVNode("i", {
                  class: "margin-left-5 fa fa-info-circle information-icon",
                  onMouseover: _cache[10] || (_cache[10] = ($event: any) => (_ctx.ShowHideGroupVisibilityTooltip(true))),
                  onMouseleave: _cache[11] || (_cache[11] = ($event: any) => (_ctx.ShowHideGroupVisibilityTooltip(false)))
                }, null, 32),
                _withDirectives(_createElementVNode("div", { class: "group-visibility-info" }, _toDisplayString(_ctx.$t("GroupVisibility.tooltip")), 513), [
                  [_vShow, _ctx.isGroupVisibilityTooltipVisible]
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}